import mockAxios, { AxiosResponse } from 'axios';
import { IQuoteServiceMock } from './quote.mock.types';

export const mockQuoteService = (): IQuoteServiceMock => ({
  fetchQuotes: jest.fn(),
  fetchQuote: jest.fn(),
  createQuote: jest.fn(),
  updateQuote: jest.fn(),
  deleteQuote: jest.fn(),
  fetchQuoteRevisions: jest.fn(),
  fetchQuoteRevision: jest.fn(),
  createQuoteRevision: jest.fn(),
  setLatestRevision: jest.fn(),
  exportQuoteItems: jest.fn(),
  exportQuoteItemsMargins: jest.fn(),
  fetchQuoteActivities: jest.fn(),
  setQuoteState: jest.fn(),
  setQuoteOwner: jest.fn(),
  uploadRfqAttachment: jest.fn(),
  downloadRfqAttachment: jest.fn(),
  setQuoteInsideSalesOwner: jest.fn(),
  setQuoteCommissionPercent: jest.fn(),
  setQuoteTargetDiscountPercent: jest.fn(),
  setQuoteRegion: jest.fn(),
  setQuoteAgent: jest.fn(),
  setQuoteComments: jest.fn(),

  setCustomerRelationshipOwner: jest.fn(),
  setBiddingEnvironment: jest.fn(),
  setClassification: jest.fn(),

  importQuoteVentilationXls: jest.fn(),
  exportQuoteProposal: jest.fn(),
  exportQuoteOrderReview: jest.fn(),
  exportQuoteXML: jest.fn(),
  exportQuoteProformaInvoice: jest.fn(),
  createOrder: jest.fn(),
  updateConfigurationItemDiscount: jest.fn(),
  updateConfigurationItemOrder: jest.fn(),
  updateConfigurationItemQuantity: jest.fn(),
  updateConfigurationItemUnitPrice: jest.fn(),
  updateConfigurationItemUnitCost: jest.fn(),
  fetchQuoteConfigurationItems: jest.fn(),
  applyGlobalDiscountPercentage: jest.fn(),
  applyFirstYearSubscriptionDiscountPercentage: jest.fn(),
  evaluateComputationPrice: jest.fn(),
  evaluateComputationDays: jest.fn(),
  calculateCoreDiscountPercent: jest.fn(),
  applyDiscountPercentages: jest.fn(),
  applySurcharges: jest.fn(),
  applySurchargeDiscountPercentage: jest.fn(),

  evaluateSurcharges: jest.fn(),
  createSalesforceOpportunity: jest.fn(),
  fetchQuotePackages: jest.fn(),
  fetchQuotePackage: jest.fn(),
  createQuotePackage: jest.fn(),
  updateQuotePackage: jest.fn(),
  setQuotePackageQuotes: jest.fn(),
  createQuoteProjectDocument: jest.fn(),
  exportQuotePackage: jest.fn()
});

export function mockQuoteAxiosResponse<T = any>(
  data?: T
): AxiosResponse<T | undefined> {
  return {
    data: data,
    status: 200,
    statusText: 'OK',
    headers: mockAxios.defaults.headers,
    config: mockAxios.defaults
  };
}
